import React from "react";
import { MessageCircle } from "lucide-react";
import { useSite, whatsappLink } from "@/context/SiteContext";

export const WhatsAppFab = () => {
  const site = useSite();
  return (
    <a
      data-testid="whatsapp-fab-button"
      href={whatsappLink(site)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message us on WhatsApp"
      className="hidden sm:flex fixed bottom-6 right-6 z-40 h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-black shadow-[0_10px_30px_rgba(0,0,0,0.45)] hover:scale-105 transition-transform"
    >
      <MessageCircle className="h-7 w-7" strokeWidth={1.75} />
    </a>
  );
};

export default WhatsAppFab;
